const languages = [
  { name: "English", code: "en" },
  { name: "Español", code: "es" },
  { name: "Français", code: "fr" },
  { name: "العربية", code: "ar" },
  { name: "हिन्दी", code: "hi" },
  { name: "বাংলা", code: "bn" },
  { name: "Português", code: "pt" },
  { name: "Tagalog", code: "tl" },
  { name: "Kiswahili", code: "sw" },
  { name: "ဗမာစာ", code: "my" },
  { name: "اردو", code: "ur" },
  { name: "Türkçe", code: "tr" },
  { name: "ភាសាខ្មែរ", code: "km" },
  { name: "Russian", code: "ru" },
  { name: "Farsi", code: "fa" },
] 

export default languages
